var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeup21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02535 2H18.9747C19.4044 2 19.7821 2.29598 19.9002 2.72528L20.9248 6.45056C21.2761 7.72819 20.3527 9 19.0736 9H4.92636C3.6473 9 2.72386 7.72819 3.07524 6.45056L4.09979 2.72528C4.21786 2.29598 4.59557 2 5.02535 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.4402V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10.4402C19.7898 10.4794 19.5722 10.5 19.3485 10.5H18C18 11.8807 16.8807 13 15.5 13C14.1193 13 13 11.8807 13 10.5H11C11 11.8807 9.88071 13 8.5 13C7.11929 13 6 11.8807 6 10.5H4.65145C4.42783 10.5 4.21018 10.4794 4 10.4402ZM8.5 20C7.11929 20 6 18.8807 6 17.5C6 16.1193 7.11929 15 8.5 15C9.88071 15 11 16.1193 11 17.5C11 18.8807 9.88071 20 8.5 20ZM18 17.5C18 18.8807 16.8807 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.1193 14.1193 15 15.5 15C16.8807 15 18 16.1193 18 17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeup21);
export default __webpack_public_path__ + "static/media/makeup-2-1.6209204674a4bd265c8627a94e595973.svg";
export { ForwardRef as ReactComponent };